export default __webpack_public_path__ + "locales/de/FilesSettings.json?hash=5220bad69cae8045d7f8df82ad4930e9";